module.exports = __webpack_public_path__ + "media/images/athletes/143-70809461e5047d81923968d6ee2fbdef.png";